import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const api = createApi({
  reducerPath: 'bffApi',
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_PUBLIC_BASE_URL }),
  keepUnusedDataFor: 1,
  endpoints: () => ({})
})
